import { IPromise, IScope } from 'angular'
import { $q } from '../../../../ng-compat/imports'
import { FulfillmentOutlet } from './Steps/types'

interface MarkUnfulfilledModalOptions {
  outlets: FulfillmentOutlet[]
}

/**
 * Controller class for the mark as unfulfilled modal
 *
 * @class MarkUnfulfilledModalController
 */
export class MarkUnfulfilledModalController {
  public readonly close: () => void
  public outlets: FulfillmentOutlet[] = []
  private readonly internalClose: (val: IPromise<any>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<any>) => void,
    public readonly options: MarkUnfulfilledModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'
    this.internalClose = close
    this.close = () => this.internalClose($q.resolve())

    this.outlets = options.outlets

    // Handle escape key
    this.vdEscapeStack.register(this.close)
    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
